import React from 'react';

import { Box, Button, ButtonGroup, Tooltip, useTheme } from '@mui/material';

import { KanbanColumn } from '../../@types/State';
import { useIntelState } from '../../context/IntelState';
import { effects } from '../../Effects';
import { findKanbanItemFromId } from '../../helpers/GeneralHelpers';

interface Props {
  isDuration: boolean;
  isEnemy: boolean;
  addColumnOp?: (op: string) => void;
  deleteColumnOp?: (op: string, column: KanbanColumn) => void;
  selectedColumn?: KanbanColumn | null;
}

const RenderOps: React.FC<Props> = ({
  isDuration,
  isEnemy,
  addColumnOp,
  deleteColumnOp,
  selectedColumn,
}) => {
  const theme = useTheme();
  const { intelState, intelDispatch } = useIntelState();
  const selectedKanbanItem = findKanbanItemFromId(
    intelState.enemyPlan,
    intelState.selectedKanbanProvinceId
  );
  const provRequiredOps = selectedKanbanItem?.province?.requiredOps ?? [];
  const list = Object.entries(effects).filter(
    ([key, value]) =>
      value.isBad === isEnemy &&
      value.isRequestable &&
      value.isDuration == isDuration
  );

  return (
    <Box
      sx={{
        paddingRight: 1,
        maxHeight: '90vh',
        overflowY: 'scroll',
        overflow: 'auto',
        scrollbarWidth: 'thin',
        '&::-webkit-scrollbar': {
          width: '0.4em',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#888',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#555',
        },
      }}
    >
      <ButtonGroup orientation='vertical'>
        {list.map(([key, value]) => {
          const alreadyPresent =
            provRequiredOps.includes(key) ||
            selectedColumn?.requiredOps?.includes(key);
          return (
            <Tooltip
              key={key}
              title={`${alreadyPresent ? 'remove' : 'add'} ${key}`}
              arrow
            >
              <Button
                variant={'outlined'}
                onClick={(e) => {
                  if (!alreadyPresent) {
                    selectedKanbanItem &&
                      intelDispatch({
                        type: 'ADD_PROVINCE_OP',
                        payload: {
                          op: key,
                          province: selectedKanbanItem?.province,
                        },
                      });
                    addColumnOp && addColumnOp(key);
                  } else {
                    selectedKanbanItem &&
                      intelDispatch({
                        type: 'DELETE_PROVINCE_OP',
                        payload: {
                          op: key,
                          province: selectedKanbanItem?.province,
                        },
                      });
                    deleteColumnOp &&
                      selectedColumn &&
                      deleteColumnOp(key, selectedColumn);
                  }
                }}
                size='small'
                sx={{
                  textTransform: 'unset',
                  backgroundColor: alreadyPresent
                    ? theme.palette.grey[
                        theme.palette.mode == 'dark' ? 600 : 300
                      ]
                    : 'transparent',
                }}
                startIcon={value.svg}
              >
                {value.shortName}
              </Button>
            </Tooltip>
          );
        })}
      </ButtonGroup>
    </Box>
  );
};
export default RenderOps;
